import gql from "graphql-tag";

export const DISPATCH_PRE_ORDER_TRIP = gql`
mutation dispatchPreOrderTrip($tripId:uuid!, $tripObj: VehicleTrip_set_input, $orderObj: Orders_set_input){
    update_VehicleTrip(where: {id:{_eq:$tripId}}, _set: $tripObj){
        returning{id}
    },
    update_Orders(where: {vehicleTripId:{_eq:$tripId}}, _set: $orderObj){
        returning{id}
    }
}`

export const DELIVER_PRE_ORDER_TRIP = gql`
mutation deliverPreOrderTrip($tripId:uuid!, $tripObj: VehicleTrip_set_input, $orderObj: Orders_set_input,
                $orgStock:[OrganizationStock_insert_input!]!, $updateColumnsOrgStock: [OrganizationStock_update_column!]!){
    update_VehicleTrip(where: {id:{_eq:$tripId}}, _set: $tripObj){
        returning{id}
    },
    update_Orders(where: {vehicleTripId:{_eq:$tripId}}, _set: $orderObj){
        returning{id}
    },    
    insert_OrganizationStock(objects: $orgStock, on_conflict: {constraint: OrganizationStock_pkey, update_columns: $updateColumnsOrgStock}){
    returning{id}
  }
}`